<template>
    <div class="position-box">
        <div class="head">
          <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
          <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
        </div>
        <div id="about" class="cotainer">
            <div class="cont">
              <div class="img-box"><img class="img" src="@/assets/new4/sucai.png" alt=""></div>
              <div class="t1">{{$t('share.hd')}}</div>
              <div class="t2">{{$t('share.yqhy')}}</div>
              <ul class="ul-box">
                <li class="li">
                  <div class="li-lt">
                    <div class="money">{{own_cp_num}}</div>
                    <div class="text">{{$t('share.yqsy')}}</div>
                  </div>
                </li>
                <li class="li">
                  <div class="li-lt">
                    <div class="money">{{own_group_num}}</div>
                    <div class="text">{{$t('share.yqrs')}}</div>
                  </div>
                </li>
              </ul>
              <div class="tips">{{$t('share.yqlj')}}</div>
              <div class="share-box" @click="copy($event)">
                <div class="share-item">
                  <div class="title">{{$t('share.lj')}}</div>
                  <div class="link">{{invite_code}}</div>
                  <img class="copy" src="@/assets/new4/fuzhi.png" alt="">
                </div>
                <div class="share-item" @click="copy($event)">
                  <div class="title">{{$t('share.yqm')}}</div>
                  <div class="link">{{link}}</div>
                  <img class="copy" src="@/assets/new4/fuzhi.png" alt="">
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
  import navBar from '@/components/NavBar.vue'
  import html2canvas from 'html2canvas';
  import VueQriously from 'vue-qriously'
export default {
    name: 'share',
    data () {
        return {
            title: '',
            cont: '',
            theme: false,
            isShow: true,
            uid: '',
            token: '',
            own_group_num: 0,
            own_cp_num: 0,
            invite_code:'',
            link:'',
            url: '',
            user: {
                // avatar: require('@/assets/icon_my_tx.jpg'),
                avatar: '',
                phone:'',
                invite_code: '',
                level: 'V0'
            },
            changMoney: '$0.00'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      // let uid = this.uid = localStorage.getItem('uid');
      // let token = this.token =localStorage.getItem('token');

      this.invite_code = localStorage.getItem('invitation_code');
      this.link = localStorage.getItem('link');
      // this.getGroupInfo();
      // this.init(uid,token);
      this.getMyPromotion()
      this.getMyPromotionTitle()
      // this.getInfoLike()
    },
    methods: {
       back(){
          this.$router.push('/index')
       },
       getMyPromotion(){
         let params = {
             token: this.token
         }
         this.$ajax.post('/web/getMyPromotion',params).then((res) => {
             // let resData = res.data.data;
             // if(res.data.code == 200){
                 this.own_cp_num = res.data.data.total;
             // }else{
             //     this.$router.push('/login')
             //     // this.$toast.bottom(res.data.msg);
             // }
         }).catch(function(err){
             console.log(err);
         })
       },
       getMyPromotionTitle(){
         let params = {
             token: this.token
         }
         this.$ajax.post('/web/getMyPromotionTitle',params).then((res) => {
             // let resData = res.data.data;
             // if(res.data.code == 200){
                 this.own_group_num = res.data.data.total;
                 // this.own_cp_num = resData.own_cp_num;
             // }else{
             //     this.$router.push('/login')
             //     // this.$toast.bottom(res.data.msg);
             // }
         }).catch(function(err){
             console.log(err);
         })
       },
       // getInfoLike(){
       //   this.$ajax.post('/web/info',).then((res) => {
       //      this.invite_code = res.data.data.invitation_code;
       //      this.link = res.data.data.link;
       //   }).catch(function(err){
       //       console.log(err);
       //   })
       // },
       getGroupInfo(){
         let params = {
             uid: this.uid,
             token: this.token
         }
         this.$ajax.post('/api/member/getGroupInfo',params).then((res) => {
             let resData = res.data.data;
             if(res.data.code == 200){
                 this.own_group_num = resData.own_group_num;
                 this.own_cp_num = resData.own_cp_num;
             }else{
                 this.$router.push('/login')
                 // this.$toast.bottom(res.data.msg);
             }
         }).catch(function(err){
             console.log(err);
         })
     },
     init(uid,token){
         let params = {
             uid: uid,
             token: token
         }
         this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {
             let resData = res.data.data;
             if(res.data.code == 200){
                 this.user = {
                     username: resData.username,
                     invite_code: resData.invite_code,
                     level: resData.level
                 }
                 let domain = window.location.host + '/reg';
             this.url = domain + '?code=' + resData.invite_code;
                 localStorage.setItem('invite_code',resData.invite_code);
                 this.haibao();
             }else{
                 this.$router.push('/login')
                 // this.$toast.bottom(res.data.msg);
             }
         }).catch(function(err){
             console.log(err);
         })
     },
    haibao(){//生成canvas
       	html2canvas(document.querySelector("#imgBox"),{
       		width: 140,
       		height: 140,
       	}).then((canvas) => {
       		this.canvasToImage(canvas)
       	});
       },
       canvasToImage(canvas){//canvas 生成图片
       	var image = new Image();
       	image.src = canvas.toDataURL("image/png");
       	$('#saveImg').attr('href',image.src)
       },
       imgDownLoad() {
           const tempElem = document.getElementById("imgBox");
           html2canvas(tempElem, {
               useCORS: true // 允许CORS跨域
           }).then(canvas => {
           　　　// 图片触发下载
               const img = canvas.toDataURL("image/jpeg").replace("data:image/jpeg;base64,", "");
               const finalImageSrc = "data:image/jpeg;base64," + img;
               const aElem = document.createElement('a');
               document.body.appendChild(aElem)
               aElem.href = finalImageSrc;
               // 设置下载标题
               aElem.download = "downLoad.png"
               aElem.click();
               document.body.removeChild(aElem);            　　　
           })
       },
       copy(e){
           let invite_code = this.user.invite_code;
           this.$copyText(invite_code, this.$t('chongbi.fzcg'));
           this.$toast.center(this.$t('chongbi.fzcg'));
       },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .cont{
        padding: .2rem .52rem;
        color: #fff;
        font-size: .4rem;
    }
    .cotainer .img-box{
      text-align: center;
    }
    .cotainer .img-box .img{
      width: 5.04rem;
    }
    .cotainer .t1{
      padding: 1rem 0 .78rem;
      color: #fff;
      font-size: .58rem;
      text-align: center;
    }
    .cotainer .t2{
      color: #7d7d7d;
      font-size: .4rem;
      text-align: center;
    }
    .cotainer .ul-box{
      display: flex;
      align-items: center;
      margin-top: 1.5rem;
      border-radius: 0.29rem;
	    border: solid 0.01rem #585858;
    }
    .cotainer .ul-box .li{
      width: 50%;
      padding: .78rem 0 .7rem;
      background: transparent!important;
      box-sizing: border-box;
      text-align: center;
    }
    .cotainer .ul-box .li .money{
      color: #000;
      font-size: .58rem;
    }
    .cotainer .ul-box .li .text{
      margin-top: .4rem;
      color: #7d7d7d;
      font-size: .4rem;
    }
    .cotainer .tips{
      padding: .88rem 0 .48rem;
      color: #fff;
      font-size: .46rem;
    }
    .cotainer .share-box{
      padding: 0 .46rem;
      border-radius: 0.29rem;
	    border: solid 0.01rem #585858;
    }
    .cotainer .share-box .share-item{
      padding: .52rem 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #585858;
    }
    .cotainer .share-box .title{
      color: #000;
      font-size: .4rem;
      word-break: keep-all;
    }
    .cotainer .share-box .link{
      flex: 1;
      margin: 0 .4rem;
      color: #000;
      font-size: .4rem;
      text-align: right;
      word-break: break-all;
    }
    .cotainer .share-box .copy{
      width: .52rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/share.vue